import script from "./uploadMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./uploadMessage.vue?vue&type=script&setup=true&lang=js"

import "./uploadMessage.vue?vue&type=style&index=0&id=e0b357aa&lang=less&scoped=true"

import exportComponent from "/ssd/code/flow-business-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e0b357aa"]])

export default __exports__